module.exports = __webpack_public_path__ + "img/boho_rio_gift_guitar.000cc0f2.svg";